import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// @ts-ignore
import { ApolloClient } from 'apollo-client';
// @ts-ignore
import { InMemoryCache } from 'apollo-cache-inmemory';
// @ts-ignore
import { HttpLink } from 'apollo-link-http';
import { ApolloProvider } from '@apollo/react-hooks';
import { setContext } from "apollo-link-context";

const httpLink  = new HttpLink({
  uri: process.env.REACT_APP_EXPRESS_API
});

const authLink = setContext((_: any, { headers }: any) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');


  // return the headers to the context so httpLink can read them
  return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : "",
      }
    }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

ReactDOM.render(<ApolloProvider client={client}> <App /></ApolloProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about queries workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
